export default __webpack_public_path__ + "static/media/service.38550d0b.svg";